<template>
  <BaseSelectInput
    :id="id"
    v-model="model"
    :default-option-text="defaultOptionText"
    :helper-text-id="helperTextId"
    :label="label"
    :name="name"
    :required="required"
    :validation-rules="validationRules"
  >
    <option
      v-for="country in countries"
      :key="country.value"
      :value="country.value"
      v-text="country.label"
    />
    <template
      v-if="helperText"
      #helperText
    >
      <p v-text="helperText" />
    </template>
  </BaseSelectInput>
</template>

<script lang="ts" setup>
import { onBeforeMount, ref } from 'vue'

import BaseSelectInput from '@js/components/global/forms/inputs/BaseSelectInput.vue'

import { Country } from '@js/api/types/address/Country'
import { getCountries } from '@js/api/address/getCountries'
import { log } from '@js/utils/logger'

defineOptions({
  name: 'BaseCountrySelect',
})

withDefaults(
  defineProps<{
    id?: string
    name?: string
    label?: string
    required?: boolean
    helperText?: string
    helperTextId?: string
    validationRules?: string
    defaultOptionText?: string
  }>(),
  {
    id: 'country',
    helperText: '',
    required: true,
    name: 'country',
    helperTextId: '',
    validationRules: 'required',
    label: 'Country of Residence',
    defaultOptionText: 'Select a country',
  },
)

const model = defineModel<string>({
  default: '',
})

const countries = ref<{ label: string, value: string }[]>([])

onBeforeMount(async (): Promise<void> => {
  try {
    const data = await getCountries()

    countries.value = data.map((country: Country) => ({
      label: country.full_name_english,
      value: country.id,
    }))
  } catch (error) {
    log({
      message: 'Country Select Field Error',
      file: 'src/wcei/js/components/global/forms/BaseCountrySelect.vue',
    })
  }
})
</script>
